export const DefaultReplayRoutes = [
  {
    path: 'default/:mode?/:content_id?',
    alias: 'automationDefault',
    query: ['channel', 'simulator-preview'],
    lazy: () => import('./defaultReply.page'),
  },
] as const
